<template>
  <div
    class="travel-cancellation-coverage-form"
    data-component="TravelCancellationCoverageForm"
  >
    <h2 class="gl_form-title">
      {{ t('copy_travel_cancellation-coverage_form-title') }}
    </h2>

    <RadioButtonGroup
      id="cancellationCoverage"
      :value="cancellationCoverage"
      :options="options"
      v-model="cancellationCoverage"
      :rules="[validationRules.required]"
      flexDirection="row"
    />
    <CardInfoComponent icon="icon-travel">
      {{ t('copy_travel_cancellation-coverage_form-hint') }}
    </CardInfoComponent>
  </div>
</template>

<script lang="ts" setup>
  import { ref } from 'vue'
  import { useI18n } from 'vue-i18n'

  import RadioButtonGroup from '@/modules/core/components/ui/RadioButtonGroupComponent.vue'
  import CardInfoComponent from '@/modules/common/common/components/panels/CardInfoComponent.vue'
  import { useRules } from '@/modules/core/composables/useRulesComposable'
  import type { OptionsValuesInterface } from '@/modules/core/models/types'
  import type TravelRaterAnswers from '../../models/APP/TravelRaterAnswers'
  import type TravelConfigurations from '@/modules/travel/common/models/APP/TravelConfigurations'

  const { t } = useI18n()
  const { required } = useRules()

  const validationRules = {
    required
  }

  defineExpose({ triggerSubmit })
  interface PropsInterface {
    nextForm: String[]
    answers: TravelRaterAnswers
    configurations: TravelConfigurations
  }
  const props = withDefaults(defineProps<PropsInterface>(), {})
  const options: OptionsValuesInterface[] = [
    { label: t('boolean-options.yes'), value: 'true' },
    { label: t('boolean-options.no'), value: 'false' }
  ]

  const cancellationCoverage = ref(
    typeof props.answers.cancellationCoverage === 'boolean'
      ? String(props.answers.cancellationCoverage)
      : 'false'
  )

  function triggerSubmit() {
    const page = props.nextForm[0]
    const answers = {
      cancellationCoverage: cancellationCoverage.value === 'true'
    }
    return { page, answers }
  }
</script>

<style lang="scss" scoped>
  .gl_form-title {
    margin-bottom: 24px;
  }
</style>
